import { Injectable, EventEmitter } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, from, Subscription, timer, Subject, firstValueFrom } from 'rxjs';
import { User } from '@app/core/types/user/User';
import {
  CodeVerificationDTO,
  CodeVerificationResponse,
  ForgetPasswordDTO,
  ResetPasswordDTO,
  SendVerificationCodeResponse,
  SetPasswordDTO,
} from '../types/user';
import { Store } from '@ngrx/store';
import { NotificationsService } from '@shared/services/notifications.service';
import { CVPActions } from '@store/actions';
import { identityServerAngularConfig, identityServerSSOConfig } from '@env/environment';
import { ToastService } from '@shared/services/toast/toast.service';
import { catchError, tap } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { UserManager, WebStorageStateStore, User as OidcUser } from 'oidc-client-ts';
import { NgxPermissionsService } from 'ngx-permissions';
import { Config, Identifiers } from '@shared/services/app.config.type';
import { IdleTimeoutService } from '@shared/services/idle-timeout.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { LoaderService } from '../loader.service';
import { throwError, EMPTY } from 'rxjs';
import { RequestCache } from '../http/request.cache.service';
import * as localforage from 'localforage';
import { appendLeadingZeros } from '../helpers';
import { CheckPermission, getType, momentCustomInstance as moment } from '@projects/shared/src/app/utils/helper';
import { Constants } from '@app/constants';
import { VisibilityService } from '@projects/shared/src/app/services/visibility.service';
import { KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { naturalSensitiveSort } from '@projects/shared/src/app/utils/sort';
import { Logger } from '../logger.service';
import { MFAFlags } from '@projects/shared/src/app/enums/MFAFlags';
import { AppConfigurationService } from '@projects/shared/src/app/services/app.configuration.service';
const log = new Logger('AuthenticationService');

export interface Credentials {
  // Customize received credentials here
  username: string;
  token: string;
}
export interface LoginContext {
  username: string;
  password: string;
  remember?: boolean;
}

const credentialsKey = 'credentials';

@Injectable()
export class AuthenticationService {
  image = new BehaviorSubject(null);
  currentImage = this.image.asObservable();
  OnTourSettingChange: EventEmitter<boolean> = new EventEmitter();
  authData: any = null;

  isLoggedIn = false;
  isSetLoggedOut = false;
  permissions: any;
  mgr!: UserManager | any;
  isSSO?: boolean;
  access_token = '';
  tenantName = '';
  isTokenExpiring = false;
  private _myStore: LocalForage;
  private readonly _myStoreName = 'auth_storage';
  private readonly _myKey: string;
  private user!: OidcUser;
  loginTimerSubscription!: Subscription;
  loginDuration: string = '00:00:00';
  sliderMeta = [
    {
      img: 'assets/styles/assets/slider-imgs/Banner-1.jpg',
      title: 'Work Without Walls.',
      description: 'From your contact center in the clouds.',
    },
    {
      img: 'assets/styles/assets/slider-imgs/Banner-2.jpg',
      title: 'Elevate agents to all-stars.',
      description: 'Help agents save the day—every day',
    },
    {
      img: 'assets/styles/assets/slider-imgs/Banner-3.jpg',
      title: 'Agents, make yourselves at home.',
      description: 'Employee attraction and retention is more competitive than ever.',
    },
  ];
  onlogout = new Subject<string>();
  onlogin = new Subject<string>();
  constructor(
    private notificationService: NotificationsService,
    private http: HttpClient,
    private router: Router,
    public toastService: ToastService,
    private idleTimeoutService: IdleTimeoutService,
    private loaderService: LoaderService,
    private store: Store<{ EventReducer: any }>,
    public ngxPermission: NgxPermissionsService,
    private oauthService: OAuthService,
    private visibiltyService: VisibilityService,
    private keycloak: KeycloakService,
    private appConfig: AppConfigurationService
  ) {
    this._myStore = localforage;
    this.initDb();
    this._myKey = 'oidc.user:' + identityServerAngularConfig.authority + ':' + identityServerAngularConfig.client_id;
    this.init();
    this.visibiltyService.visibilityChange.subscribe((e: any) => {
      if (e.target.hidden) {
        this.endLoginStatusTimer();
      } else {
        this.startLoginStatusTimer();
      }
    });
  }

  async initDb() {
    this._myStore.config({
      name: this._myStoreName,
    });
  }

  async initUser() {
    // const user = await this.mgr?.getUser();
    // return user;
    let isLoggedIn = await this.keycloak.isLoggedIn();
    if (isLoggedIn) {
      const user = await this.keycloak.loadUserProfile();
      this.keycloak.getToken().then((access_token) => {
        this.access_token = access_token;
      });
      return user;
    }
    return null;
  }

  init() {
    if (this.keycloak.isLoggedIn()) {
      this.keycloak.getToken().then((access_token) => {
        this.access_token = access_token;
      });
      this.keycloak.keycloakEvents$.subscribe({
        next: (e) => {
          if (e.type == KeycloakEventType.OnTokenExpired) {
            this.keycloak.updateToken().then((updated) => {
              updated
                ? console.log(new Date().toLocaleString() + ' Token is updated')
                : console.error('Token is update error.');
            });
          }
        },
      });
    }

    if (localStorage.getItem('authorizationData') != null) {
      const data = JSON.parse(localStorage.getItem('authorizationData') || 'null');

      if (Object.keys(data).length === 1 && Object.keys(data)[0] === 'ConfiguredChannels') return;

      this.authData = data;
    }
    console.log(
      new Date().toLocaleString() +
        ' ➤ authentication.service.ts ➤ init(): [line 160] ==> Setting authData , type = ' +
        typeof this.authData
    );
  }

  // init() {
  //   const config = {
  //     authority: identityServerAngularConfig.authority,
  //     client_id: identityServerAngularConfig.client_id,
  //     redirect_uri: identityServerAngularConfig.redirect_uri,
  //     response_type: identityServerAngularConfig.response_type,
  //     scope: identityServerAngularConfig.scope,
  //     post_logout_redirect_uri: identityServerAngularConfig.post_logout_redirect_uri,
  //     silent_redirect_uri: identityServerAngularConfig.silent_redirect_uri,
  //     accessTokenExpiringNotificationTime: identityServerAngularConfig.accessTokenExpiringNotificationTime,
  //     automaticSilentRenew: identityServerAngularConfig.automaticSilentRenew,
  //     userStore: new LocalForageStateStore(),
  //     clockSkew: identityServerAngularConfig.clockSkew,
  //   };
  //   this.mgr = new UserManager(config);
  //   const auth = localStorage.getItem('authorizationData');
  //   if (auth != null) {
  //     this.authData = JSON.parse(auth);
  //     localStorage.setItem('cleanUpUserId', this.authData.Id);
  //   }
  //   this.mgr.getUser().then((user: any) => {
  //     this.user = user;
  //   });
  //   this.onTokenExpiring();
  // }

  public async getToken() {
    if (this.checkIsSSOLogin() == true) {
      return this.getSSOToken();
    } else {
      if (await this.isUserLoggedIn()) return this.access_token;
      else this.logout();
      return '';
    }
  }

  // public getTokenAsync(): Observable<string> {
  public async getTokenAsync(): Promise<Observable<string>> {
    if (this.checkIsSSOLogin()) {
      return from(this.getSSOToken());
    } else {
      if (await this.isUserLoggedIn()) {
        let token = await this.keycloak.getToken();
        return from(token);
      }
      return from('');
    }
  }

  private onTokenExpiring() {
    // this.mgr?.events.addAccessTokenExpiring(() => {
    //   this.isTokenExpiring = true;
    //   // console.log(new Date().toLocaleString() + ' token expiring...');
    //   this.setNewToken(this.user.access_token);
    // });
  }

  checkIsSSOLogin(): boolean {
    const isSSOLogin = localStorage.getItem('isSSOLogin') || 'null';
    return JSON.parse(isSSOLogin);
  }

  setNewToken(currToken: string) {
    // console.log(new Date().toLocaleString() + ' current token : ' + currToken);
    setTimeout(
      () => {
        console.info('getToken >> wait 500ms so that token get refreshed');
        this.mgr?.getUser().then((user: any) => {
          this.isTokenExpiring = false;
          this.user = user;
          if (this.user.access_token == currToken) {
            // console.log(new Date().toLocaleString() + ' new token is still same: ' + this.user.access_token);
            this.setNewToken(currToken);
          } else {
            // console.log(new Date().toLocaleString() + ' new token after refreshed: ' + this.user.access_token);
          }
        });
      },
      500,
      currToken
    );
  }

  isMfaChannelVerified(mfaChannel: MFAFlags) {
    let isMfaVerified = false;

    if (localStorage.getItem('authorizationData') != null) {
      const authData = JSON.parse(localStorage.getItem('authorizationData') || 'null');

      if (authData?.ConfiguredChannels) {
        const mfaFlags = Number(authData.ConfiguredChannels) as MFAFlags;
        console.log(new Date().toLocaleString() + ' MFA flags => ', mfaFlags);
        console.log(new Date().toLocaleString() + ' MFA Channel => ', mfaChannel);
        console.log(new Date().toLocaleString() + ' MFA => ', mfaFlags & mfaChannel);

        isMfaVerified = (mfaFlags & mfaChannel) !== 0;
      }
    }

    return isMfaVerified;
  }

  configureMFAAuthData(isEnable: boolean, mfaFlag: MFAFlags) {
    let authData: any = {};

    if (localStorage.getItem('authorizationData') != null) {
      authData = JSON.parse(localStorage.getItem('authorizationData') || 'null');
    }

    if (authData?.ConfiguredChannels) {
      const currentMFAFlags = authData.ConfiguredChannels as MFAFlags;
      authData.ConfiguredChannels = isEnable ? currentMFAFlags | mfaFlag : currentMFAFlags & ~mfaFlag;
    } else if (isEnable) {
      authData.ConfiguredChannels = mfaFlag;
    }

    console.log(
      new Date().toLocaleString() +
        ' ➤ authentication.service.ts ➤ configureMFAAuthData(): [line 280] ==> Setting authData , type = ' +
        getType(authData)
    );
    this.appConfig.setAuthData(authData);
    localStorage.setItem('authorizationData', JSON.stringify(authData));
  }

  public async getIndexedDbAuthData(): Promise<string | null> {
    const item: any = await this._myStore.getItem(this._myKey);
    //console.log(`get key: ${this._myKey}, value: ${item}.`);
    if (item) return item.toString();
    return null;
  }
  public removeIndexedDbItem(): Promise<string | null> {
    this._myStore.removeItem(this._myKey);
    return Promise.resolve(null);
  }

  changeCurrentImage(image: any) {
    this.image.next(image);
  }

  getClientId() {
    return this.authData ? this.authData.ClientId : null;
  }

  getUserId() {
    return this.authData ? this.authData.Id : null;
  }

  public getUserManager(): UserManager | null {
    return this?.mgr;
  }

  public getCurrentUser(): Observable<OidcUser> {
    const oidcUser: Observable<OidcUser> = this.mgr.getUser();
    return from(oidcUser);
  }

  public getCurrentUserToken(): Observable<string> {
    return from(this.keycloak.getToken());
  }

  public getCurrentUserTokenn(): Promise<string> {
    return this.keycloak.getToken();
  }

  public completeAuthentication(): Observable<void> {
    const oidcUser: Observable<void> = this.mgr.signinRedirectCallback().then((user: any) => {
      this.user = user;
    });
    return from(oidcUser);
  }

  async login() {
    this.clearAuthData();
    localStorage.removeItem('isSSOLogin');
    localStorage.removeItem('ssoClient');
    localStorage.removeItem('ssoToken');

    if (!this.isUserLoggedIn()) await this.keycloak.login();
    else this.router.navigate(['/']);

    // this.mgr
    //   .getUser()
    //   .then((user: any) => {
    //     if (user) {
    //       this.isLoggedIn = true;
    //     } else {
    //       this.isLoggedIn = false;
    //       this.mgr.signinRedirect();
    //     }
    //   })
    //   .catch((e: any) => {
    //     this.loaderService.showMain = false;
    //     this.router.navigate(['/oops']);
    //   });
  }

  signinRedirect() {
    // this.mgr.signinRedirect();
    this.keycloak
      .login()
      .then(() => {})
      .catch((e) => {
        this.loaderService.showMain = false;
        this.router.navigate(['/oops']);
      });
  }

  signinCallback() {
    return this.mgr.signinCallback();
  }

  async signoutRedirect() {
    this.keycloak.getToken().then((token) => {
      // if keycloak service token is undefined, we don't need to call logout on keycloak
      if (token) {
        this.keycloak
          .logout()
          .then(() => {})
          .catch((e) => {
            this.loaderService.showMain = false;
            this.router.navigate(['/oops']);
          });
      } else {
        this.router.navigate(['/login']);
      }
    });
  }

  // signoutRedirect() {
  //   const userId = localStorage.getItem('cleanUpUserId');
  //   if (userId) {
  //     this.cleanup(userId).subscribe((e) => {
  //       if (!this.authData) {
  //         //localStorage.removeItem('cleanUpUserId');
  //         window.localStorage.clear();
  //       }
  //       if (this.user)
  //         this.mgr
  //           .signoutRedirect({ id_token_hint: this.user.id_token, state_data: this.user.session_state })
  //           .then(() => console.log(new Date().toLocaleString() + ' User is signout successfully with ids..'));
  //       else this.mgr.signoutRedirect().then(() => console.log(new Date().toLocaleString() + ' User is signout successfully..'));
  //     });
  //   } else {
  //     if (this.user)
  //       this.mgr
  //         .signoutRedirect({ id_token_hint: this.user.id_token, state_data: this.user.session_state })
  //         .then(() => console.log(new Date().toLocaleString() + ' User is signout successfully with ids..'));
  //     else this.mgr.signoutRedirect().then(() => console.log(new Date().toLocaleString() + ' User is signout successfully..'));
  //   }
  // }
  async sleep(msec: number) {
    return new Promise((resolve) => setTimeout(resolve, msec));
  }
  async logout(isIdleTimeout: boolean = false) {
    //cleanup telephony and add logout status
    console.log(`${new Date().toDateString()} logout [authentication.service.ts] line 457 => logout() event called`);
    let user = this.authData;
    if (user) {
      this.onlogout.next(Constants.STATUSES.LoggedOut.FriendlyName);
    }

    let isForce = window.localStorage.getItem('isForceLogout');
    if (!isForce) {
      this.addLoggedOutStatus(Constants.STATUSES.LoggedOut.FriendlyName);
    }
    window.localStorage.removeItem('isForceLogout');
    localStorage.removeItem('last_status');

    const isSSOLogin = JSON.parse(localStorage.getItem('isSSOLogin') || 'null');
    const isUserReloggedIn = JSON.parse(localStorage.getItem('isUserReloggedIn') || 'null');

    //this.logUserLogout();
    this.clearAuthData();
    this.isSetLoggedOut = true;
    this.isLoggedIn = false;

    if (!isSSOLogin) {
      console.trace();
      console.log(
        new Date().toLocaleString() + ' [authentication.service.ts] logout() line 391, localStorage clear() called'
      );
      window.localStorage.clear();
      if (isIdleTimeout) {
        localStorage.setItem('isIdleTimeout', JSON.stringify(true));
        this.idleTimeoutService.postIdleTimoutMessage();
      } else {
        if (isUserReloggedIn) {
          localStorage.setItem('isUserReloggedIn', JSON.stringify(true));
        }
        this.idleTimeoutService.postSigningOutMessage();
      }
      const tenant = this.getTenantName();
      localStorage.setItem('tenant', tenant);
      // this.keycloak.clearToken();
      // debugger;
      this.keycloak.getToken().then((token) => {
        // if keycloak service token is undefined, we don't need to call logout on keycloak
        if (token) {
          this.keycloak
            .logout()
            .then(() => {
              if (isIdleTimeout) {
                localStorage.setItem('isIdleTimeout', JSON.stringify(true));
                this.idleTimeoutService.postIdleTimoutMessage();
              } else {
                if (isUserReloggedIn) {
                  localStorage.setItem('isUserReloggedIn', JSON.stringify(true));
                }
                this.idleTimeoutService.postSigningOutMessage();
              }
            })
            .catch((e) => {
              this.loaderService.showMain = false;
              this.router.navigate(['/oops']);
            });
        } else {
          this.router.navigate(['/login']);
        }
      });

      // this.mgr
      //   .getUser()
      //   .then((user: any) => {
      //     if (user) {
      //       this.removeIndexedDbItem().then(() => {
      //         //window.localStorage.clear();
      //         if (isIdleTimeout) {
      //           localStorage.setItem('isIdleTimeout', JSON.stringify(true));
      //           this.idleTimeoutService.postIdleTimoutMessage();
      //         } else {
      //           if (isUserReloggedIn) {
      //             localStorage.setItem('isUserReloggedIn', JSON.stringify(true));
      //           }
      //           this.idleTimeoutService.postSigningOutMessage();
      //         }
      //         const tenant = this.getTenantName();
      //         localStorage.setItem('tenant', tenant);
      //         this.signoutRedirect();
      //       });
      //     } else {
      //       if (isIdleTimeout) {
      //         localStorage.setItem('isIdleTimeout', JSON.stringify(true));
      //         this.idleTimeoutService.postIdleTimoutMessage();
      //       } else {
      //         if (isUserReloggedIn) {
      //           localStorage.setItem('isUserReloggedIn', JSON.stringify(true));
      //         }
      //         this.idleTimeoutService.postSigningOutMessage();
      //       }
      //       const tenant = this.getTenantName();
      //       localStorage.setItem('tenant', tenant);
      //       this.signoutRedirect();
      //     }
      //   })
      //   .catch((e: any) => {
      //     this.loaderService.showMain = false;
      //     this.router.navigate(['/oops']);
      //   });
    } else {
      // this.oauthService.tokenEndpoint = identityServerTCIConfig.authority + '/connect/token';
      // this.oauthService.clientId = identityServerTCIConfig.client_id;
      // this.oauthService.scope = identityServerTCIConfig.scope;
      // this.oauthService.dummyClientSecret = identityServerTCIConfig.secret;

      this.router.navigate(['/logoutsso']);
      this.oauthService.logOut();
    }
  }

  storeAuthData(response: any): Observable<any> {
    const data = response;
    this.checkTokenExpiry(data.expiry);
    return this.requireAuthentication();
  }

  getSSOToken(): string {
    let token = null;
    const authData = JSON.parse(localStorage.getItem('authorizationData') || 'null');
    if (authData) token = authData?.token;

    return token;
  }

  getExpiryDate(secs: number): Date {
    const t = new Date();
    t.setSeconds(t.getSeconds() + secs);
    return t;
  }

  isTokenExpired(expires_in: number) {
    if (!expires_in) {
      return true;
    }

    const seconds = 1000;
    const d = new Date();
    const t = d.getTime();

    if (expires_in < Math.round(t / seconds)) {
      return true;
    }
    return false;
  }

  checkTokenExpiry(expiry?: number) {
    if (expiry) {
      if (this.isTokenExpired(expiry)) {
        console.trace();
        //log.error('[authentication.service.ts] checkTokenExpiry line 519, localStorage clear() called');
        localStorage.clear();
        // localStorage.removeItem('isSSOLogin');
        // localStorage.removeItem('ssoClient');
        // localStorage.removeItem('ssoToken');
        this.router.navigate(['/endsession']);
      }
    } else {
      this.getIndexedDbAuthData().then((ls: any) => {
        ls = JSON.parse(ls);
        if (ls && this.isTokenExpired(ls.expires_at)) {
          console.trace();
          //log.error('[authentication.service.ts] line 530, localStorage clear() called');
          console.log(new Date().toLocaleString() + ' checkTokenExpiry ➤  window.localStorage.clear()');

          localStorage.clear();
          //   localStorage.removeItem('isSSOLogin');
          // localStorage.removeItem('ssoClient');
          // localStorage.removeItem('ssoToken');
          this.router.navigate(['/endsession']);
        }
      });
    }
  }

  saveSsoAuthToken(response: any) {
    const currentData = JSON.parse(localStorage.getItem('authorizationData') || 'null');
    if (currentData != null) {
      this.logUserLogout();
      this.clearAuthData();
    }

    const data = response;
    this.authData = { token: data.access_token, expiry: data.expiry };

    console.log(
      new Date().toLocaleString() +
        ' ➤ authentication.service.ts ➤ saveSsoAuthToken(): [line 599] ==> Setting authData , type = ' +
        getType(this.authData)
    );
    this.appConfig.setAuthData(this.authData);
    localStorage.setItem('authorizationData', JSON.stringify(this.authData));
    localStorage.setItem('isSSOLogin', JSON.stringify(true));
  }

  onSignIn(user: any): any {
    this.authData = user;

    if (localStorage.getItem('authorizationData') != null) {
      const existingAuthdata = JSON.parse(localStorage.getItem('authorizationData') || 'null');
      if (existingAuthdata != null) {
        this.authData = { ...this.authData, ...existingAuthdata };
      }
    }
    console.log(
      new Date().toLocaleString() +
        ' ➤ authentication.service.ts ➤ onSignIn(): [line 615] ==> Setting authData , type = ' +
        getType(this.authData)
    );
    this.appConfig.setAuthData(this.mapData(this.authData));
    localStorage.setItem('authorizationData', JSON.stringify(this.mapData(this.authData)));
    this.store.dispatch(new CVPActions.PermissionEventAction.PermissionEvent(''));
    this.logLastUserLogout();
    return this.authData;
  }

  onLogOut() {
    localStorage.removeItem('authorizationData');
    localStorage.removeItem('configData');
    localStorage.removeItem('last_status');
    this.signoutRedirect();
  }

  syncTwoFactor(userId: string): any {
    // Check if user is back from keycloak two factor screen...
    localStorage.removeItem('enableTwoFactor');
    return this.updateTwoFactorStatus(userId, true);
  }

  getTourGuide() {
    const permission = this.ngxPermission.getPermissions();
    const tourGuideAllowed = permission[Identifiers.TourGuide] ? true : false;

    if (this.authData && this.authData.UserSettings && tourGuideAllowed) {
      return this.authData.UserSettings.TourGuide;
    } else {
      return false;
    }
    // return (this.authData && this.authData.UserSettings) ? this.authData.UserSettings.TourGuide : false;
  }

  updateMarket(user: User): Observable<any> {
    const url = '/user/market';
    return this.http.put(url, user);
  }

  getLanguage(): Observable<any> {
    const DefaultLanguage = localStorage.getItem('language') || 'en-CA';
    return this.http.get(`/multilingual/${DefaultLanguage}`);
  }

  clearAuthData() {
    this.notificationService.clearAsync().subscribe(() => {
      this.notificationService.clearAsync2().subscribe(() => {
        this.authData = null;
        localStorage.removeItem('authorizationData');
        localStorage.removeItem('configData');
      });
    });
  }

  public requireAuthentication(): Observable<any> {
    if (!this.authData) {
      const url = '/user/userclaims';
      return this.http
        .skipErrorHandler()
        .get(url)
        .pipe(
          tap((response: any) => {
            return response;
          }),
          catchError((error) => this.errorHandler(error))
        );
    } else {
      return EMPTY;
    }
  }

  public mapData(data: any) {
    delete data.FeatureIds;

    //data.DefaultMarketLanguage = data.Markets[0].DefaultLanguage || environment.defaultMarketLanguage;

    data.Features = data.Features.map(function (x: any) {
      return {
        Id: x.Id,
        ClientId: x.ClientId,
        ParentId: x.ParentId,
        Name: x.Name,
        Icon: x.Icon,
      };
    });
    return data;
  }

  storeLastUserInfo() {
    this.init();
    if (this.authData) {
      localStorage.setItem('lastLoginUser', JSON.stringify(this.authData));
    }
  }

  getLastUserInfo() {
    if (localStorage.getItem('lastLoginUser') != null) {
      return localStorage.getItem('lastLoginUser');
    } else {
      return null;
    }
  }
  getUserLanguageByCode() {
    return this.authData.Markets[0].Languages.map((value: any) => {
      return value.Code;
    });
  }
  getMarketDefaultLanguage() {
    return this.authData.DefaultMarketLanguage;
  }
  getClientLogo() {
    return this.authData.ClientInfo.Logo['portal'] || '';
  }
  getClientFabIcon() {
    return this.authData.ClientInfo.Logo['fav_icon'] || '';
  }

  getClientLogoType(type: string) {
    return this.authData.ClientInfo.Logo[type];
  }
  getClientThemes() {
    return this.mapThemesUrls(this.authData.ClientInfo.Themes || []);
  }
  getClientName() {
    return this.authData.ClientName;
  }
  getClientThemeImage(theme: string, type: string) {
    const value = this.authData.ClientInfo.Themes.find((x: any) => x.Field === theme);
    if (value) {
      return value[type];
    }
    return '';
  }
  logLastUserLogout() {
    const user: any = this.getLastUserInfo();
    if (user) {
      const url = '/activity/logs';
      const data = [
        {
          CreatedOn: new Date(), // moment().utc().format('DD MMM YYYY hh:mm a'),
          Type: 'EXPIRED',
          CreatedBy: user.Id,
          UserName: (user.FirstName || '') + ' ' + (user.LastName || ''),
          ClientId: user.ClientId === '' ? null : user.ClientId,
          MarketId: user.MarketId === '' ? null : user.MarketId,
        },
      ];
      this.http.post(url, data);
      localStorage.removeItem('lastLoginUser');
      this.endLoginStatusTimer();
    }
  }
  logUserLogout() {
    this.init();
    if (this.authData) {
      const url = '/activity/logs';
    }
  }

  updateLanguage(language: any) {
    this.authData.DefaultLanguage = language.Code;
    this.authData.MarketId = language.MarketId;
    console.log(
      new Date().toLocaleString() +
        ' ➤ authentication.service.ts ➤ updateLanguage(): [line 774] ==> Setting authData , type = ' +
        getType(this.authData)
    );
    this.appConfig.setAuthData(this.authData);
    localStorage.setItem('authorizationData', JSON.stringify(this.authData));
    localStorage.setItem('language', language.Code);
  }

  updateTheme(theme: any, dialpadTheme: any) {
    this.authData.UserSettings.Theme = theme;
    this.authData.UserSettings.DialpadTheme = dialpadTheme;
    console.log(
      new Date().toLocaleString() +
        ' ➤  authentication.service.ts ➤ updateTheme(): [line 782] ==> Setting authData , type = ' +
        getType(this.authData)
    );
    console.log(new Date().toLocaleString() + ' ➤ Auth data updated on updateTheme => ', this.authData);
    this.appConfig.setAuthData(this.authData);
    localStorage.setItem('authorizationData', JSON.stringify(this.authData));
  }

  updateProfilePic(profilePic: string) {
    this.authData.ProfilePic = profilePic;
    console.log(
      new Date().toLocaleString() +
        ' ➤  authentication.service.ts ➤ updateProfilePic(): [line 788] ==> Setting authData , type = ' +
        getType(this.authData)
    );
    this.appConfig.setAuthData(this.authData);
    localStorage.setItem('authorizationData', JSON.stringify(this.authData));
  }

  getTheme() {
    return this.authData.UserSettings.Theme;
  }

  getDialpadTheme() {
    return this.authData.UserSettings.DialpadTheme;
  }

  sendVerificationCode(data: any): Observable<any> {
    const url = '/user/sendverificationcode';
    return this.http.post<any>(url, data);
  }

  sendMfaVerificationCode(data: any): Observable<SendVerificationCodeResponse> {
    const url = '/user/sendmfaverificationcode';
    return this.http.post<any>(url, data);
  }

  verifyCode(data: CodeVerificationDTO): Observable<CodeVerificationResponse> {
    const url = '/user/verifycode';
    return this.http.post<any>(url, data);
  }

  handleVerificationError(error: string): void {
    switch (error) {
      case 'INVALID_CODE':
        this.toastService.error('Invalid verification code.');
        break;
      case 'CODE_EXPIRED':
        this.toastService.error('The verification code has expired. Please request a new code.');
        break;
      case 'INVALID_CHANNEL':
        this.toastService.error('Unknown Multi-factor authentication channel is selected.');
        break;
      default:
        this.toastService.error('Unable to verify the confirmation code. Please try again later.');
        break;
    }
  }

  expired() {
    this.storeLastUserInfo();
    this.clearAuthData();
  }

  setPassword(data: SetPasswordDTO): Observable<any> {
    const url = '/user/setpassword/';
    return this.http.put<any>(url, data);
  }

  changePassword(id: any, data: any): Observable<any> {
    const url = '/user/changepassword';
    return this.http.put<any>(url, data);
  }

  forgotPassword(data: ForgetPasswordDTO): Observable<any> {
    const url = '/user/forgotpassword';
    return this.http.post<any>(url, data);
  }

  validateResetToken(guid: any) {
    const url = '/user/link/' + guid;
    return this.http.get(url);
  }

  resetPassword(data: ResetPasswordDTO): Observable<any> {
    const url = '/user/resetpassword/';
    return this.http.put<any>(url, data);
  }

  getUserClient(id: any): Observable<any> {
    const url = '/user/userclient/';
    return this.http.get(url + id);
  }

  getClientByName(name: any): Observable<any> {
    const url = '/client/GetByName/';
    return this.http.get(url + name);
  }

  getPasswordPolicy(id: any): Observable<any> {
    const url = '/client/ispasswordpolicy/';
    return this.http.get(url + id);
  }

  enabledTwoFactor(): void {
    //localStorage.setItem('enableTwoFactor', this.getUserId());
    //this.authData = null;
    //localStorage.removeItem('authorizationData');
    //60mint
    this.keycloak.login({ action: 'CONFIGURE_TOTP', maxAge: 3600 }); //"CONFIGURE_TOTP"
    // this.keycloak.login({ action: 'webauthn-register' , maxAge: 3600 });//"Webauthn_Register"
  }

  enabledPasskeyFlow(): void {
    //localStorage.setItem('enableTwoFactor', this.getUserId());
    //this.authData = null;
    //localStorage.removeItem('authorizationData');
    this.keycloak.login({ action: 'webauthn-register', maxAge: 3600 });
  }

  IsInRole(roles: any) {
    return !!(roles.indexOf(this.authData.Role) === -1);
  }

  getTokenParams(data: any): Observable<any> {
    const url = '/user/extractparams';
    return this.http.post<any>(url, data);
  }

  async isUserLoggedIn() {
    // const value = !!JSON.parse(
    //   localStorage.getItem(
    //     'oidc.user:' + identityServerAngularConfig.authority + ':' + identityServerAngularConfig.client_id
    //   )
    // );
    // return value;

    // if (this.user != null && this.user !== undefined) return true;

    // return false;

    if (await this.keycloak.isLoggedIn()) return true;
    else return false;
  }

  async loadUserProfile(forceReload: boolean) {
    return this.keycloak.loadUserProfile(forceReload);
  }

  isAuthenticated() {
    const value = !!this.authData;
    return value;
  }

  IsInPermission(feature: any, permission: any) {
    return !!(
      this.authData.Features.findIndex(function (x: any) {
        return x.Feature === feature && x.FeatureOption === permission;
      }) === -1
    );
  }

  getUser() {
    // this.init();
    if (this.authData) {
      return this.authData;
    }
    return null;
  }

  getUserInitials() {
    if (this.authData) {
      let fullName = this.authData.FirstName.substring(0, 1) ?? '';
      const lastName = this.authData.LastName.substring(0, 1) ?? '';

      if (fullName && lastName) fullName += lastName;

      return fullName.toUpperCase();
    }
    return '';
  }

  getUserFullName() {
    if (this.authData) {
      let fullName = this.authData.FirstName;
      const lastName = this.authData.LastName;

      if (fullName && lastName) fullName += ' ' + lastName;

      return fullName;
    }
    return '';
  }

  getUserAssignedTFNS() {
    if (this.authData) {
      let tfns = this.authData.AssignedTfns;
      if (tfns) {
        return tfns.join(',');
      }
    }
    return '';
  }

  getAntiForgeryToken() {
    const url = '/user/antiforgerytoken';
    return this.http.get(url);
  }

  getProgram() {
    return this.authData && this.authData.ClientInfo ? this.authData.ClientInfo.DealerEvent : 'NVS';
  }

  isUserExist(id: string) {
    const url = '/user/sso/' + id;
    return this.http.get(url);
  }

  ssoLogin(data: any) {
    const url = '/user/sso';
    return this.http.post(url, data);
  }

  cleanup(userId: string) {
    const data = {
      UserId: userId,
    };
    const url = identityServerAngularConfig.authority + 'api/v1/user/cleanup';
    return this.http.post(url, data);
  }

  getSSOConfiguration(name: string) {
    const url = identityServerSSOConfig.authority + '/api/v1/configuration/ssoconfiguration/' + name;
    return this.http.get(url);
  }

  createUser(user: any): Observable<any> {
    return this.http.post<any>('/user', user);
  }

  public initSSO(cId: string) {
    let clientId = identityServerSSOConfig.client_id;
    if (cId != null && cId != '') {
      clientId = cId;
    }
    const config = {
      authority: identityServerSSOConfig.authority,
      client_id: clientId,
      redirect_uri: identityServerSSOConfig.redirect_uri,
      response_type: identityServerSSOConfig.response_type,
      scope: identityServerSSOConfig.scope,
      post_logout_redirect_uri: identityServerSSOConfig.post_logout_redirect_uri,
      silent_redirect_uri: identityServerSSOConfig.silent_redirect_uri,
      accessTokenExpiringNotificationTime: identityServerSSOConfig.accessTokenExpiringNotificationTime,
      automaticSilentRenew: identityServerSSOConfig.automaticSilentRenew,
      userStore: new WebStorageStateStore({ store: window.localStorage }),
    };

    this.mgr = new UserManager(config);
    this.isSSO = true;
  }

  getTenantName() {
    const tenant = localStorage.getItem('tenant');
    if (tenant !== null && tenant !== '' && tenant) {
      return tenant;
    } else {
      return '';
    }
  }

  private mapThemesUrls(themes: any) {
    themes.forEach((theme: any) => {
      theme.PreviewImage = theme.PreviewImage;
    });
    return themes;
  }

  private errorHandler(response: any): Observable<HttpEvent<any>> {
    // console.log(response);
    if (!environment.production) {
      // Do something with the error
      if (response.status === 401) {
        this.router.navigate(['/endsession']);
      }
    }

    switch (response.status) {
      case 0:
        this.router.navigate(['/oops']);
        break;
      case 400:
        if (response.error.type == 'InvalidMFAChannel') {
          this.router.navigate(['/mfa-notsupported']);
        } else {
          this.router.navigate(['/oops']);
        }
        break;
      case 401:
        this.router.navigate(['/endsession']);
        break;
      case 404:
        this.router.navigate(['/oops']);
        break;
      case 422:
        this.router.navigate(['/oops']);
        break;
      case 429:
        this.router.navigate(['/oops']);
        break;
      case 500:
        this.router.navigate(['/oops']);
        break;
      case 501:
        this.router.navigate(['/oops']);
        break;
      case 502:
        this.router.navigate(['/oops']);
        break;
      case 503:
        this.router.navigate(['/oops']);
        break;
      case 504:
        this.router.navigate(['/oops']);
        break;
      case 505:
        this.router.navigate(['/oops']);
        break;
      case 511:
        this.router.navigate(['/oops']);
        break;
      default:
        this.router.navigate(['/oops']);
        break;
    }

    return throwError(response);
  }

  setLoginTime() {
    if (this.isAuthenticated()) {
      const login = window.localStorage.getItem('login_time');
      if (!login) {
        window.localStorage.setItem('login_time', new Date().toString());
      }
    }
  }

  endLoginStatusTimer() {
    if (this.loginTimerSubscription) {
      this.loginTimerSubscription.unsubscribe();
    }
    this.loginDuration = '00:00:00';
  }

  startLoginStatusTimer() {
    if (this.loginTimerSubscription) {
      this.endLoginStatusTimer();
    }

    let hour: any = 0;
    let sec: any = 0;
    let min: any = 0;

    const login_time = window.localStorage.getItem('login_time');
    if (login_time) {
      const date = moment(new Date(login_time));
      const now = moment();
      hour = now.diff(date, 'hours') % 60;
      min = now.diff(date, 'minutes') % 60;
      sec = now.diff(date, 'seconds') % 60;
      if (sec >= 60) {
        min += 1;
        sec = 0;
        if (min == 60) {
          min = 0;
          sec = 0;
          hour += 1;
        }
      }
    }

    this.loginTimerSubscription = timer(0, 1000).subscribe((x: number) => {
      sec += 1;
      if (sec == 60) {
        min += 1;
        sec = 0;
        if (min == 60) {
          min = 0;
          sec = 0;
          hour += 1;
        }
      }
      this.loginDuration = appendLeadingZeros(hour) + ':' + appendLeadingZeros(min) + ':' + appendLeadingZeros(sec);
    });
  }

  addLoggedInStatus(status: string) {
    // const check = window.localStorage.getItem('login_status');
    // if (check) {
    //   return;
    // }
    // window.localStorage.setItem('login_status', 'true');
    let data = {
      Status: status,
      UserId: this.authData.Id,
      Version: '1.0.0',
      Campaigns: this.authData.Campaigns?.map((x: any) => ({ Id: x.Id, Name: x.Name, Code: x.Code })),
      Date: moment().toISOString(),
    };
    this.http.post<any>(Constants.APIS.USER.STATUS_LOG, data).subscribe((x: any) => {
      console.log(new Date().toLocaleString() + ' User login status added in database');
    });
  }

  addLoggedOutStatus(status: string) {
    // const check = window.localStorage.getItem('login_status');
    // if (check) {
    //window.localStorage.removeItem('image');

    if (!this.authData) return;

    let data = {
      Status: status,
      //here
      //[GlobalErrorHandler] Uncaught (in promise): TypeError: Cannot read properties of null (reading 'Id')
      UserId: this.authData.Id,
      Version: '1.0.0',
      Campaigns: this.authData.Campaigns?.map((x: any) => ({ Id: x.Id, Name: x.Name, Code: x.Code })),
      Date: moment().toISOString(),
    };
    this.http.post<any>(Constants.APIS.USER.STATUS_LOG, data).subscribe((x: any) => {
      console.log(new Date().toLocaleString() + ' User login status added in database');
    });
    //}
  }

  /**
   * Get default campaign of current loggedin user.
   * @returns {CampaignDTO | null}
   */
  getDefaultCampaign(): CampaignDTO | null {
    if (this.authData && this.authData.Campaigns && this.authData.Campaigns.length > 0) {
      return this.authData.Campaigns[0] as CampaignDTO;
    }

    return null;
  }

  getAllCampaignCode() {
    if (this.authData && this.authData.Campaigns && this.authData.Campaigns.length > 0) {
      //console.log(this.authData.Campaigns);
      return this.authData.Campaigns.map((campaign: CampaignDTO) => campaign.Code);
    }

    return null;
  }

  getAllCampaigns() {
    if (this.authData && this.authData.Campaigns && this.authData.Campaigns.length > 0) {
      return this.authData.Campaigns;
    }

    return null;
  }

  getAllClientCampaigns() {
    if (this.authData && this.authData.ClientCampaigns && this.authData.ClientCampaigns.length > 0) {
      return naturalSensitiveSort([...this.authData.ClientCampaigns]).asc('Code');

      // return this.authData.ClientCampaigns;
    }

    return null;
  }

  public getAllAssignedCenters() {
    let centers: any[] = [];
    const supervisorCenters = this.authData?.CampaignInfo?.Supervisor?.Centers;
    if (Array.isArray(supervisorCenters) && supervisorCenters.length > 0) {
      centers = centers.concat(supervisorCenters);
    }
    const agentCenter = this.authData?.CampaignInfo?.Agent?.Center;
    if (agentCenter) {
      const exists = centers.some((center: any) => center.Code === agentCenter.Code);
      if (!exists) {
        centers.push(agentCenter);
      }
    }

    return centers.length ? naturalSensitiveSort([...centers]).asc('Code') : null;
  }

  public getAllAssignedCentersCampaign() {
    const supervisorCenters = this.authData?.CampaignInfo?.Supervisor?.Campaigns || [];
    const agentCenters = this.authData?.CampaignInfo?.Agent?.Campaigns || [];

    const centers = [...supervisorCenters, ...agentCenters];

    const uniqueCenters = Array.from(new Map(centers.map((item) => [item.Id, item])).values());

    return uniqueCenters.length ? naturalSensitiveSort(uniqueCenters).asc('Code') : null;
  }

  getCurrentCenter() {
    this.authData.Center = { Selected: this.authData?.CampaignInfo?.Supervisor?.SelectedCenter };
    this.authData.Center.CampaignId = this.authData?.CampaignInfo?.Supervisor?.SelectedCampaignId;
    if (this.authData && this.authData.Center) {
      return this.authData.Center;
    }

    return null;
  }

  getDialingCountries() {
    if (this.authData && this.authData.DialingCountries && this.authData.DialingCountries.length > 0) {
      return this.authData.DialingCountries;
    }

    return null;
  }

  isNoAuthUrl() {
    let allowedPaths = [
      'resetpassword',
      'forgotpassword',
      'sso',
      'oops',
      'idle-timeout',
      'session-message',
      'signout-message',
      'code-verification',
      //'recovery-code',
      'recovery-code-verification',
      'set-password',
      'post-logout',
      'ext-signout-callback',
      'forbidden',
    ];
    return allowedPaths.find((a) => location.pathname.includes(a));
  }

  verifyRecoveryCode(data: any) {
    const url = '/user/verifyrecoverycode';
    return this.http.post(url, data);
  }

  updateTwoFactorStatus(userId: string, status: boolean) {
    const url = `/user/updatetwofactorstatus`;
    return this.http.put(url, {
      Id: userId,
      Status: status,
    });
  }

  setAuthData(data: any) {
    this.authData = data;
  }

  //* return max count reached

  async fetchTodayCallbacksCount(): Promise<any> {
    const allCampaignCodes = [...this.getAllCampaignCode()];
    const callbackLimitCampaigns =
      this.appConfig.getByIdentifier('ScriptSkillCodesAndTFNS').Fields['CALL_BACK_COUNT_LIMIT_CAMPAIGNS'] ?? '';
    const callbackLimitCampaignsArray = callbackLimitCampaigns.split(',').map((str: string) => str.trim());
    // Check if any user campaign codes match the limit list
    const hasMatch = callbackLimitCampaignsArray.some((str: string) => allCampaignCodes.includes(str));
    // Case 1: No match found. Return a resolved promise with 'false'
    if (!hasMatch) {
      return false; // Since the method is 'async', returning a raw value automatically wraps it in a Promise
    }
    // Formatting dates for the API request
    const startDate = moment().utc().startOf('day').toISOString();
    const endDate = moment().utc().endOf('day').toISOString();
    // Constructing query parameters
    const url = `${Constants.APIS.CALL.CALLBACK_COUNT}?StartDate=${startDate}&EndDate=${endDate}&Campaigns=${callbackLimitCampaigns}`;
    // Case 2: Match found. Convert the HTTP Observable into a Promise and return it
    return firstValueFrom(this.http.get(url));
  }
  getTelephonyProvider() {
    if (this.authData && this.authData.ClientInfo?.Provider?.TelephoneProvider) {
      return this.authData?.ClientInfo?.Provider?.TelephoneProvider?.toLowerCase();
    }

    return null;
  }
  updateCenterAndCampaign(center: string, campaign: string) {
    if (this.authData?.CampaignInfo?.Supervisor) {
      this.authData.CampaignInfo.Supervisor.SelectedCenter = center;
      this.authData.CampaignInfo.Supervisor.SelectedCampaignId = campaign;
    }
    this.authData.Center.Selected = center;
    this.authData.Center.CampaignId = campaign;
    console.log(
      new Date().toLocaleString() +
        ' ➤ authentication.service.ts ➤ updateCenterAndCampaign(): [line 1382] ==> Setting authData , type = ' +
        getType(this.authData)
    );
    this.appConfig.setAuthData(this.authData);
    localStorage.setItem('authorizationData', JSON.stringify(this.authData));
  }

  public agentDefaultUrl() {
    const agentDashboard = CheckPermission('agent', 'agent_dashboard', this);
    const agentCalls = CheckPermission('agent', 'agent_calls', this);
    const agentChat = CheckPermission('agent', 'agent_chat', this);
    const agentStats = CheckPermission('agent', 'agent_statistics', this);
    if (!agentDashboard && agentCalls) {
      const agentCallsCampaign = CheckPermission('agent_calls', 'agent_calls_campaign', this);
      const agentCallsCallBack = CheckPermission('agent_calls', 'agent_calls_callBack', this);
      const agentCallsLeads = CheckPermission('agent_calls', 'agent_calls_leads', this);
      const agentStatisticsMeetingSchedular = CheckPermission('agent_calls', 'agent_statistics_meetingSchedular', this);
      if (agentCallsCampaign) {
        Constants.Apps.Agent.defaultPath = '/agent/calls/campaign';
      } else if (agentCallsCallBack) {
        Constants.Apps.Agent.defaultPath = '/agent/calls/callback';
      } else if (agentCallsLeads) {
        Constants.Apps.Agent.defaultPath = '/agent/calls/leads';
      } else if (agentStatisticsMeetingSchedular) {
        Constants.Apps.Agent.defaultPath = '/agent/statistics/meeting-schedular';
      }
    } else if (!agentDashboard && agentChat) {
      const agentChatLive = CheckPermission('agent_chat', 'agent_chat_live', this);
      const agentChatmyTranscript = CheckPermission('agent_chat', 'agent_chat_myTranscript', this);
      if (agentChatLive) {
        Constants.Apps.Agent.defaultPath = '/agent/chats/live';
      } else if (agentChatmyTranscript) {
        Constants.Apps.Agent.defaultPath = '/agent/chats/my-transcript';
      }
    } else if (!agentDashboard && agentStats) {
      const agentStatsMyCalls = CheckPermission('agent_statistics', 'agent_statistics_myCalls', this);
      const agentStatsMySales = CheckPermission('agent_statistics', 'agent_statistics_mySales', this);
      const agentStatsMyLeaderboard = CheckPermission('agent_statistics', 'agent_statistics_leaderboard', this);
      if (agentStatsMyCalls) {
        Constants.Apps.Agent.defaultPath = '/agent/stats/summaries/my-calls';
      } else if (agentStatsMySales) {
        Constants.Apps.Agent.defaultPath = '/agent/stats/summaries/my-sales';
      } else if (agentStatsMyLeaderboard) {
        Constants.Apps.Agent.defaultPath = '/agent/stats/leaderboard';
      }
    }
    console.log(new Date().toLocaleString() + ' Routing to default page', Constants.Apps.Agent.defaultPath);
  }

  public QADefaultUrl() {
    const insights = CheckPermission('insights', '', this);
    if (!insights) {
      const QA = CheckPermission('QA', '', this);
      const QARecording = CheckPermission('QA', 'quality_recording_list', this);
      const QAEvaluation = CheckPermission('QA', 'quality_evaluation_list', this);
      const QAEvaluationSup = CheckPermission('QA', 'quality_evaluation_list_sup', this);
      const QAVoicemail = CheckPermission('QA', 'quality_voicemail_list', this);
      if (QA && QARecording) {
        Constants.Apps.Supervisor.defaultPath = '/supervisor/insight/agent-call-evaluation/call-list';
      } else if (QA && QAEvaluation) {
        Constants.Apps.Supervisor.defaultPath = '/QA/evaluation/view-evaluation-list';
      } else if (QA && QAEvaluationSup) {
        Constants.Apps.Supervisor.defaultPath =
          '/supervisor/insight/agent-call-evaluation/view-submitted-evaluation-list';
      } else if (QA && QAVoicemail) {
        Constants.Apps.Supervisor.defaultPath = '/supervisor/insight/agent-call-evaluation/voicemail';
      }
      console.log(new Date().toLocaleString() + ' Routing to default page', Constants.Apps.Supervisor.defaultPath);
    }
  }

  public backstageDefaultUrl() {
    const backstageUser = CheckPermission('admin', 'admin_user', this);
    const backstageTfn = CheckPermission('admin', 'admin_tfn', this);
    if (backstageUser) {
      Constants.Apps.Admin.defaultPath = '/admin/user/list';
    } else if (backstageTfn) {
      Constants.Apps.Admin.defaultPath = '/admin/tfn/list';
    }
    console.log(new Date().toLocaleString() + ' Routing to default page', Constants.Apps.Admin.defaultPath);
  }

  public getOutboundBusinessHours(): Observable<any> {
    const CampaignId = this.authData.Campaigns.length > 0 ? this.authData.Campaigns[0].Id : '';
    return this.http.get(`/campaigns/outbound-businesshours/${CampaignId}`);
  }
  setByIdentifier(identifier: string, data: any) {
    if (!this.authData) return;
    const index = this.authData.Configurations.findIndex((x: any) => x.Identifier == identifier);
    if (index != -1) {
      this.authData.Configurations[index].Fields = data;
    }
    console.log(
      new Date().toLocaleString() +
        ' ➤ app.configuration.service.ts ➤ setByIdentifier(): [line 28] ==> Setting authData , type = ' +
        getType(this.authData)
    );
    this.appConfig.setAuthData(this.authData);
    localStorage.setItem('authorizationData', JSON.stringify(this.authData));
  }
  getByIdentifier(identifier: string) {
    if (!this.authData) return;
    let config = this.authData.Configurations;
    if (config) {
      const conff: any = config.find((conf: Config) => {
        return conf.Identifier === identifier;
      });
      return conff ? conff : false;
    } else {
      return false;
    }
  }
}

interface CampaignDTO {
  Code: string;
  Id: string;
  Name: string;
  Settings: {
    Note: boolean;
    ExtraStatus: Array<{
      Name: string;
      FriendlyName: string;
      Key: string;
      Icon: string;
      IsEnabled: boolean;
    }>;
    AutoShiftStatus: {
      From: string;
      To: string;
      IntervalStart: number;
      IntervalEnd: number;
      IsImplemented: boolean;
    };
  };
}
